import Modal from './Modal';
import './Modal.scss';

export default Modal;
